export default {
  pageNavbar: [
    {
      name: "Lakiery i akcesoria",
      anchor: "color"
    },
    {
      name: "Akscesoria",
      anchor: "accessories"
    },
    {
      name: "Lakiery",
      anchor: "upholstering"
    },
    {
      name: "Tapicerka",
      anchor: "seats"
    },
    {
      name: "Inne",
      anchor: "features"
    }
  ],
  equipmentHeaderSub: "Sprawdź",
  equipmentHeader: "Akcesoria",
  upholsteringHeaderSub: "Design",
  upholsteringHeader: "Lakiery",
  gallerySlider: [
    {
      header: "Stylizacja zewnętrzna",
      images: [
        {
          name: "Dolne listwy drzwi",
          image: "accessories/listwy-progowe.jpg"
        },
        {
          name: "Osłona dolna zderzaka tylnego",
          image: "accessories/oslona-dolna-zderzaka-tylnego.jpg"
        },
        {
          name: "Nakładka ochronna krawędzi bagażnika",
          image: "accessories/listwa-pokrywy-bagaznika.jpg"
        },
        {
          name: "Napis „Eclipse Cross” ",
          image: "accessories/Napis.jpg"
        }
      ]
    },
    {
      header: "STYLIZACJA WEWNĘTRZNA I KOMFORT",
      images: [
        {
          name: "Komplet aluminiowych nakładek na pedały",
          image: "accessories/nakladki-na-pedaly-matowane-aluminium.jpg"
        },
        {
          name: "Nakładki progowe z napisem PHEV. Wzór „Carbon”",
          image: "accessories/nakladki-progowe-stal-nierdzewna.jpg"
        },
        {
          name: "Dywaniki tekstylne, 2 rodzaje materiału",
          image: "accessories/dywaniki-tekstylne-3-rodzaje-materialu.jpg"
        }
      ]
    },
    {
      header: "BEZPIECZEŃSTWO I OCHRONA",
      images: [
        {
          name: "Kuweta bagażnika",
          image: "accessories/kuweta-bagaznika.jpg"
        },
        {
          name: "Chlapacze przednie i tylne",
          image: "accessories/chlapacze-przednie-i-tylne.jpg"
        },
        {
          name: "Czarna folia ochronna zderzaka tylnego",
          image: "accessories/folia-ochronna.jpg"
        }
      ]
    },
    {
      header: "TRANSPORT",
      images: [
        {
          name: "Uchwyt na rower",
          image: "accessories/uchwyt-na-rower.jpg"
        },
        {
          name: "Uchwyt na narty / snowboard",
          image: "accessories/uchwyt-na-narty--snowboard.jpg"
        },
        {
          name: "Bagażnik rowerowy na hak holowniczy",
          image: "accessories/bagaznik-rowerowy-na-hak-holowniczy.jpg"
        }
      ]
    },
    {
      header: "AKCESORIA DO ŁADOWANIA",
      images: [
        {
          name:
            "Do publicznych lub specjalnych domowych stacji ładowania (z wyjątkiem stacji szybkiego ładowania), długość 6 m.",
          image: "accessories/przewod-do-ladowania.jpg"
        },
        {
          name: "Torba na przewód do ładowania",
          image: "accessories/torba-na-przewod-do-ladowania.jpg"
        }
      ]
    }
  ],
  carSlider: [
    {
      car: "car-1.png",
      icon: "icon-car-1.png",
      name: "Biały diamentowy"
    },
    {
      car: "car-2.png",
      icon: "icon-car-2.png",
      name: "Czerwień diamentowa"
    },
    {
      car: "car-3.png",
      icon: "icon-car-3.png",
      name: "Niebieski metalizowany"
    },
    {
      car: "car-4.png",
      icon: "icon-car-4.png",
      name: "Srebrny metalizowany"
    },
    {
      car: "car-5.png",
      icon: "icon-car-5.png",
      name: "Grafitowy metalizowany"
    },
    {
      car: "car-6.png",
      icon: "icon-car-6.png",
      name: "Brązowy metalizowany"
    },
    {
      car: "car-7.png",
      icon: "icon-car-7.png",
      name: "Czarny metalizowany"
    },
    {
      car: "car-8.png",
      icon: "icon-car-8.png",
      name: "Biały niemetalizowany"
    }
  ],
  seatsSlider: [
    {
      background: "1_2.png",
      seat: "1.png",
      desc: "CZARNA CZĘŚCIOWO SKÓRZANA"
    },
    {
      background: "2_2.png",
      seat: "2.png",
      desc: "Jasnoszara skórzana"
    },
    {
      background: "3_2.png",
      seat: "3.png",
      desc: "Czarna skórzana"
    }
  ]
};
